"use strict";
import React from "react";
import { Link } from "react-router-dom";
import vehicleSummary from "./vehicleSummary";
import vehicleDetail from "./vehicleDetail";

const initComponent = (flex = window.flex) => {

    const VehicleSummary = vehicleSummary(flex);
    const VehicleDetail = vehicleDetail(flex);

    class VdpNav extends React.PureComponent {
        render() {
            const vehicle = this.props.vehicle || {};
            const build = vehicle.build || {};
            const listingContext = this.props.listingContext;
            return (
                <div>
                    <div className="breadcrumbs xs-hidden">
                        <Link to="/">Home</Link>
                        <Link to="/workbench">Workbench</Link>
                        <span>{build.title}</span>
                    </div>

                    <div className="alt-links left xs-visible print-hidden">
                        <Link to="/workbench">Back to Workbench</Link>
                    </div>

                    <div className="btn-split-group xs-hidden">
                        <Link to={`/workbench/vdp/${listingContext.previousIndex}`} className="btn pull-left">&lt; Previous Vehicle</Link>
                        <Link to={`/workbench/vdp/${listingContext.nextIndex}`} className="btn pull-right">Next Vehicle &gt;</Link>
                    </div>

                    <div className="row">

                        <div className="alt-links left xs-hidden col-sm-6">

                        </div>


                        <div className="alt-links xs-hidden col-sm-6">
                            <Link to="../../patterns/05-sellerportal-04-pages-02-vdp/05-sellerportal-04-pages-02-vdp.html">Seller View</Link>
                            <a href="#">Retail View</a>
                            <a href="#">Print This Page</a>
                        </div>
                    </div>
                </div>
            );
        }
    }

    class VdpAlerts extends React.Component {
        render() {
            return (
                <div className="xs-hidden" data-set="mandatory-alert">
                    <div className="alert alert-danger rover">
                        <p>This vehicle is mandatory</p>
                    </div>
                </div>
            );
        }
    }

    class VdpSpecs extends React.Component {
        render() {
            const vehicle = this.props.vehicle || {};
            const build = vehicle.build || {};
            return (
                <section id="vehicle-specifications" className="vdp-section vehicle-specifications">
                    <h2>Vehicle Specifications</h2>

                    <div className="row">
                        <dl className="specs col-sm-3">
                            <dt>Body Style:</dt>
                            <dd>{build.bodyStyleDescription}</dd>

                            <dt>Doors:</dt>
                            <dd>{build.doors}</dd>

                            <dt>Engine:</dt>
                            <dd>{build.engineDescription}</dd>

                            <dt>Transmission:</dt>
                            <dd>{build.transmissionDescription}</dd>
                        </dl>

                        <dl className="specs col-sm-3">
                            <dt>Drive Train:</dt>
                            <dd>{build.driveTrain}</dd>

                            <dt>Speeds:</dt>
                            <dd>{build.numberOfGears}</dd>

                            <dt>Fuel Type:</dt>
                            <dd>{build.fuelTypeDescription}</dd>

                        </dl>

                        <dl className="specs col-sm-3">
                            <dt>Exterior Color:</dt>
                            <dd>{build.manufacturerColorDescription}</dd>

                            <dt>Interior Color:</dt>
                            <dd>{build.interiorTrimColor || (build.interiorColor ? build.interiorColor.summary : false)}</dd>

                            <dt>Interior Type:</dt>
                            <dd>{build.upholsteryDescription}</dd>
                        </dl>

                        <dl className="specs col-sm-3">
                            <dt>Title State:</dt>
                            <dd>Georgia</dd>

                            <dt>Title Status:</dt>
                            <dd>Clean</dd>

                            <dt>In-Service Date:</dt>
                            <dd>09/01/2013</dd>
                        </dl>
                    </div>
                </section>
            );
        }
    }

    class VdpAnnouncements extends React.Component {
        render() {
            return (
                <section id="announcements" className="vdp-section announcements">
                    <h2>Announcements</h2>
                    <div className="info">
                        <p><strong>Frame Damage:</strong></p>
                        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas commodo, nibh a finibus tincidunt, magna risus lacinia enim, vel tempus dui metus ultricies nisl. Vivamus felis quam, laoreet sed lorem eget, euismod imperdiet odio. Duis ac dolor non velit aliquet gravida. Cras id nulla imperdiet, ultricies lectus ac, egestas massa. Pellentesque nec magna orci. Vivamus ut elit eu elit rhoncus fringilla sit amet sit amet mi. Etiam elit nibh, facilisis sed mi nec, feugiat rutrum nibh. Integer tellus nibh, finibus luctus gravida et, rhoncus nec quam.</p>
                    </div>
                </section>
            );
        }
    }

    class VdpDisclaimer extends React.Component {
        render() {
            return (
                <section id="seller-disclaimer" className="vdp-section seller-disclaimer">
                    <h2>Seller Disclaimer</h2>

                    <div className="info">
                        <p>Toyota/Lexus Financial Services makes no guaranty that any manufacturer service campaign or recall work has been undertaken or performed on vehicles sold at auction. All dealers are encouraged to inspect vehicles prior to purchase and to perform any service campaigns or recalls repairs (and to perform any state mandated smog or safety checks) prior to resale of the vehicle. Toyota/Lexus Financial Services makes no guaranty that any manufacturer service campaign or recall work has been undertaken or performed on vehicles sold at auction. All dealers are encouraged to inspect vehicles prior to purchase and to perform any service campaigns or recalls repairs (and to perform any state mandated smog or safety checks) prior to resale of the vehicle.</p>
                    </div>
                </section>
            );
        }
    }

    class VdpHistory extends React.Component {
        render() {
            return (
                <section id="vehicle-history-report" className="vdp-section vehicle-history-report">
                    <h2>Vehicle History Report</h2>

                    <a href="#" className="icon-links" target="_blank">
                        <img src="/content/img/carfax-logo.png" alt="Carfax" />
                    </a>

                    <a href="#" className="icon-links" target="_blank">
                        <img src="/content/img/autocheck-logo.png" alt="AutoCheck" />
                    </a>
                </section>
            );
        }
    }

    class VdpBuildData extends React.Component {
        render() {
            const vehicle = this.props.vehicle || {};
            const build = vehicle.build || {};
            const packages = {};
            const otherOptions = [];
            if (vehicle.build.options)
                vehicle.build.options.forEach(function (option, index) {
                    const packSummary = option.pack ? option.pack.summary : false;
                    if (!option.option || !option.option.summary) return false;
                    if (!packSummary) return otherOptions.push(option.option.summary);
                    let pack = packages[packSummary];
                    if (!pack) pack = packages[packSummary] = { summary: packSummary, options: [] };
                    pack.options.push(option.option.summary);
                    return true;
                });
            const packageComponents = packages === {} ? false : Object.keys(packages).map(function (packSummary, index) {
                const pack = packages[packSummary];
                return (
                    <div key={`pack-${index}`}>
                        <h4>{packSummary}</h4>
                        <div className="row">
                            {pack.options.map(function (option, optIndex) {
                                return (
                                    <span key={`pack-${index}-option-${optIndex}`} className="specs specs-list col-sm-3">{option}</span>
                                );
                            })}
                        </div>
                    </div>
                );
            });

            const otherOptionComponents = !otherOptions.length ? false : otherOptions.map(function (option, optIndex) {
                return (
                    <span key={`other-option-${optIndex}`} className="specs specs-list col-sm-3">{option}</span>
                );
            });
            return (
                <section id="build-data" className="vdp-section build-data">
                    <h2>Build Data</h2>

                    <h3>Included Packages</h3>

                    {packageComponents}



                    <h3>Additional Options</h3>

                    <div className="row">

                        {otherOptionComponents}

                    </div>
                </section>
            );
        }
    }

    class VdpEquipment extends React.Component {
        render() {
            return (
                <section id="equipment" className="vdp-section equipment">
                    <h2>Equipment</h2>
                    <div className="row">
                        <ul className="specs specs-list col-sm-3">
                            <li>115V Power Outlet</li>
                            <li>ABS Brakes</li>
                            <li>AM/FM</li>
                            <li>Air Conditioning</li>
                            <li>Aux. Audio Input</li>
                            <li>Bluetooth</li>
                        </ul>

                        <ul className="specs specs-list col-sm-3">
                            <li>CD Player</li>
                            <li>Climate Control</li>
                            <li>Cruise Control</li>
                            <li>Driver Airbag</li>
                            <li>Dual Zone Climate Control</li>
                            <li>Fog Lights</li>
                        </ul>

                        <ul className="specs specs-list col-sm-3">
                            <li>Heated Seat</li>
                            <li>Intermittent Wipers</li>
                            <li>Keyless Entry</li>
                            <li>Leather Interior Surface</li>
                            <li>Leather Steering Wheel</li>
                            <li>Navigation System</li>
                        </ul>

                        <ul className="specs specs-list col-sm-3">
                            <li>Passenger Airbag</li>
                            <li>Power Door Locks</li>
                            <li>Power Drivers Seat</li>
                            <li>Power Mirrors</li>
                            <li>Power Passenger Seat</li>
                            <li>Power Steering</li>
                        </ul>
                    </div>
                </section>
            );
        }
    }

    class VdpCondition extends React.Component {
        render() {
            return (
                <section id="condition-information" className="vdp-section condition-information">
                    <h2>Condition Information</h2>
                    <div className="row">
                        <dl className="specs col-sm-3">
                            <dt>Frame Damage:</dt>
                            <dd>None</dd>

                            <dt>Prior Paint:</dt>
                            <dd>???</dd>

                            <dt>Driveable:</dt>
                            <dd>Yes</dd>
                        </dl>

                        <dl className="specs col-sm-3">
                            <dt>Odor:</dt>
                            <dd>None</dd>

                            <dt>Keys:</dt>
                            <dd>2</dd>

                            <dt>Manuals:</dt>
                            <dd>1</dd>
                        </dl>

                        <dl className="specs col-sm-3">
                            <dt>Engine Starts:</dt>
                            <dd>Yes</dd>

                            <dt>Inspection Date:</dt>
                            <dd>01/01/2015</dd>

                            <dt>Inspected By:</dt>
                            <dd>Inspector 37</dd>
                        </dl>
                    </div>
                </section>
            );
        }
    }

    class VdpDamages extends React.Component {
        render() {
            return (
                <section id="damage-summary" className="vdp-section damage-summary">
                    <h2>Damage Summary</h2>

                    <div className="damage-entry">
                        <h3>Cosmetic Conventional Paint and Body Not Required (1 item)</h3>

                        <div className="row">
                            <div className="col-sm-2 damage-thumb">
                                <img src="/content/img/vdp-thumb.jpg" alt="Photo of damage" />
                            </div>

                            <div className="col-xs-6 col-sm-3">
                                <dl>
                                    <dt>Description:</dt>
                                    <dd>L Rocker Panel Outer</dd>
                                </dl>
                            </div>

                            <div className="col-xs-6 col-sm-3">
                                <dl>
                                    <dt>Condition:</dt>
                                    <dd>Dent/No Paint Dmg</dd>
                                </dl>
                            </div>

                            <div className="col-xs-6 col-sm-3">
                                <dl>
                                    <dt>Severity:</dt>
                                    <dd>1&quot; to 2&quot;</dd>
                                </dl>
                            </div>
                        </div>
                    </div>

                    <div className="damage-entry">
                        <h3>Paint and Body Requires Conventional Repair (2 items)</h3>

                        <div className="row">
                            <div className="col-sm-2 damage-thumb">
                                <img src="/content/img/vdp-thumb.jpg" alt="Photo of damage" />
                            </div>

                            <dl className="col-xs-6 col-sm-3">
                                <dt>Description:</dt>
                                <dd>Front Bumper Cover</dd>
                            </dl>

                            <dl className="col-xs-6 col-sm-3">
                                <dt>Condition:</dt>
                                <dd>Curb Rash</dd>
                            </dl>

                            <dl className="col-xs-6 col-sm-3">
                                <dt>Severity:</dt>
                                <dd>GR 12&quot;</dd>
                            </dl>
                        </div>

                        <div className="row">
                            <div className="col-sm-2 damage-thumb">
                                <img src="/content/img/vdp-thumb.jpg" alt="Photo of damage" />
                            </div>

                            <dl className="col-xs-6 col-sm-3">
                                <dt>Description:</dt>
                                <dd>Rear Bumper Cover</dd>
                            </dl>

                            <dl className="col-xs-6 col-sm-3">
                                <dt>Condition:</dt>
                                <dd>Curb Rash</dd>
                            </dl>

                            <dl className="col-xs-6 col-sm-3">
                                <dt>Severity:</dt>
                                <dd>GR 12&quot;</dd>
                            </dl>
                        </div>
                    </div>
                </section>
            );
        }
    }

    class VdpTires extends React.Component {
        render() {
            return (
                <section id="tires-wheels" className="vdp-section tires-wheels">
                    <h2>Tires & Wheels</h2>

                    <div className="row tire-specs">
                        <dl className="col-xs-6 col-sm-2">
                            <dt>Left Front:</dt>
                            <dd>
                                <p>7/32&quot;</p>
                                <p>Michelin</p>
                                <p>p24/60r18</p>
                            </dd>
                        </dl>

                        <dl className="col-xs-6 col-sm-2">
                            <dt>Right Front:</dt>
                            <dd>
                                <p>7/32&quot;</p>
                                <p>Michelin</p>
                                <p>p24/60r18</p>
                            </dd>
                        </dl>

                        <dl className="col-xs-6 col-sm-2">
                            <dt>Left Rear:</dt>
                            <dd>
                                <p>7/32&quot;</p>
                                <p>Michelin</p>
                                <p>p24/60r18</p>
                            </dd>
                        </dl>

                        <dl className="col-xs-6 col-sm-2">
                            <dt>Right Rear:</dt>
                            <dd>
                                <p>7/32&quot;</p>
                                <p>Michelin</p>
                                <p>p24/60r18</p>
                            </dd>
                        </dl>

                        <dl className="col-xs-6 col-sm-2">
                            <dt>Spare:</dt>
                            <dd>
                                <p>Not Included</p>
                            </dd>
                        </dl>

                        <dl className="col-xs-6 col-sm-2">
                            <dt>Wheels</dt>
                            <dd>
                                <p>Alloy</p>
                            </dd>
                        </dl>
                    </div>
                </section>
            );
        }
    }

    class VdpServices extends React.Component {
        render() {
            return (
                <section id="additional-services" className="vdp-section additional-services">
                    <h2>Additional Services</h2>

                    <a href="#" className="icon-links" target="_blank">
                        <img src="/content/img/ready-auto-logo.jpg" alt="Ready Auto Transport" />
                        <span className="print-hidden">Get Quote</span>
                    </a>
                </section>
            );
        }
    }

    class VdpDetail extends React.Component {
        render() {
            return (
                <section id="car-details" className="vdp-section additional-services">
                    <h2>Car Details</h2>
                </section>
            );
        }
    }

    class Vdp extends React.PureComponent {
        static defaultProps = {
            vehicle: false
        };

        componentDidMount() {
            flex.scrollToTop(1);
        }

        render() {
            const self = this;
            const listings = this.props.listings;
            const currentIndex = parseInt(this.props.currentIndex);
            const previousIndex = currentIndex === 0 ? 0 : currentIndex - 1;
            const nextIndex = currentIndex === listings.length - 1 ? listings.length - 1 : currentIndex + 1;
            if (!listings || !listings.length || currentIndex < 0 || currentIndex > listings.length) flex.navigate("/workbench");
            const vehicle = listings[currentIndex];
            const vehicleDetail = this.props.vehicle ? <VehicleDetail vehicle={this.props.vehicle} /> : false;
            return (
                <section className="container" role="main">

                    <VdpNav listingContext={{ currentIndex: currentIndex, previousIndex: previousIndex, nextIndex: nextIndex }} vehicle={vehicle} />
                    <VdpAlerts vehicle={vehicle} />

                    <VehicleSummary vehicle={vehicle} />

                    <div className="jump-to">
                        <h3>Jump to:</h3>
                        <div className="alt-links left">
                            <a href="#vehicle-specifications">Vehicle Specifications</a>
                            <a href="#announcements">Announcements</a>
                            <a href="#seller-disclaimer">Seller Disclaimer</a>
                            <a href="#vehicle-history-report">Vehicle History Report</a>
                            <a href="#build-data">Build Data</a>
                            <a href="#equipment">Equipment</a>
                            <a href="#condition-information">Condition Information</a>
                            <a href="#damage-summary">Damage Summary</a>
                            <a href="#tires-wheels">Tires & Wheels</a>
                            <a href="#additional-services">Additional Services</a>
                            <a href="#car-details">Car Details</a>
                        </div>
                    </div>


                    <VdpSpecs vehicle={vehicle} />
                    <VdpAnnouncements vehicle={vehicle} />
                    <VdpDisclaimer vehicle={vehicle} />
                    <VdpHistory vehicle={vehicle} />
                    <VdpBuildData vehicle={vehicle} />
                    <VdpEquipment vehicle={vehicle} />
                    <VdpCondition vehicle={vehicle} />
                    <VdpDamages vehicle={vehicle} />
                    <VdpTires vehicle={vehicle} />
                    <VdpServices vehicle={vehicle} />
                    <VdpDetail vehicle={vehicle} />


                    <a href="#top" className="btn back-to-top-btn smooth-scroll">Back to Top</a>
                    {vehicleDetail}
                </section>

            );
        }
    };

    return Vdp;
};

module.exports = initComponent;
